import { ConfigRecord } from "./ConfigRecord";
import * as GlobalTypes from "../../types";
import Locale from '../../utils/Locale';

export type EnergyRatesRecord = ConfigRecord<EnergyRatesConfig>;
export class EnergyRatesConfig {
    Electricity: ElectricityPrices = new ElectricityPrices();
    Gas: GasPrices = new GasPrices();
};

export class ElectricityPrices {
    AutoFill: boolean = false;
    Dayparts: Daypart[] = [
        {
            Name: Locale.gettext("All Day"),
            Price: 0.17, // Also default of Interview/energy prices
            From: '00:00',
            To: '24:00'
        }
    ];
}

export class GasPrices {
    Naturalgas: GlobalTypes.NumberOrString = 1.81; // Also default of Interview/energy prices
    NaturalgasUnit: GlobalTypes.GasUnits = 'ccf'; // Also default of Interview/energy prices
    Propane: GlobalTypes.NumberOrString = 2.46; // Also default of Interview/energy prices
    PropaneUnit: GlobalTypes.GasUnits = 'gallon'; // Also default of Interview/energy prices
};

export class Daypart {
    Name: string;
    Price: GlobalTypes.NumberOrString;
    From: GlobalTypes.TimeString;
    To: GlobalTypes.TimeString;
}